import qs from 'qs';

import axiosInstance from '../protected';

import {getImportsUrl, getImportUrl, getServiceRequestsUrl} from '../api.config';

import {IPageable, IPageableDto} from '../../shared/types/pageable.types';
import {
  IServiceRequestImports,
  IServiceRequestImportsPostBody,
  LoadType,
} from '../../shared/types/serviceRequestImport.types';
import {IDocument, TypeDoc} from '../../shared/types/document.types';

export const ServiceRequestImportService = {
  async getAll(
    attr: {
      pageable?: IPageable;
      spec?: any;
    } = {},
  ) {
    const res = await axiosInstance.get<IPageableDto<IServiceRequestImports>>(getImportsUrl(), {
      params: {
        ...attr.pageable,
        ...attr.spec,
      },
      paramsSerializer: {
        serialize: (params) => {
          return qs.stringify(params, {arrayFormat: 'repeat'});
        },
      },
    });

    return res;
  },

  async getById(id: string) {
    const res = await axiosInstance.post<IServiceRequestImports[]>(getImportsUrl(`/findByIds`), [id]);

    return {data: res.data[0]};
  },

  async update(data: IServiceRequestImports) {
    const updated = await axiosInstance.put<IServiceRequestImports>(getImportsUrl(), data);

    return updated;
  },

  async delete(id: string) {
    await axiosInstance.delete(getImportsUrl(`/${id}`));
  },

  async deleteAFew(IDs: string[]) {
    const deleted = await axiosInstance.delete<string[]>(getImportsUrl(), {
      params: {
        id: IDs,
      },
      paramsSerializer: {
        serialize: (params) => {
          return qs.stringify(params, {arrayFormat: 'repeat'});
        },
      },
    });

    return deleted;
  },

  async create(data: IServiceRequestImportsPostBody, importType: 'serviceRequest' | 'workData') {
    const created = await axiosInstance.post<IServiceRequestImports>(getImportsUrl(`/${importType}`), data);

    return created;
  },

  async findByIDs(IDs: string[]) {
    const res = await axiosInstance.post<IServiceRequestImports[]>(getImportsUrl(`/findByIDs`), IDs);

    return res;
  },

  async attachDoc(id: string, data: FormData) {
    const created = await axiosInstance.post<IDocument>(getImportsUrl(`/${id}/documents`), data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return created;
  },

  async attachApproved(params: {comment: string; taskId: number}, data: FormData) {
    const res = await axiosInstance.post<unknown>(getServiceRequestsUrl('/excel/approve'), data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      params: {
        ...params,
      },
    });

    return res;
  },

  async import(
    data: {deviceType: string | null; docType: TypeDoc; taskId: number; loadType: LoadType},
    formData: FormData,
  ) {
    const res = await axiosInstance.post<IServiceRequestImports>(getImportUrl(`/upload`), formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      params: data,
    });

    return res;
  },
};
